export const IF_START_STATEMENT: string = '{% if ';
export const CLOSING_TAG: string = ' %}';
export const ELSE_STATEMENT: string = '{% else %}'
export const IF_END_STATEMENT: string = '{% endif %}';
